export default "__VITE_ASSET__BA$1sOeD__"